import Image from "next/image";

export interface KrystalProps {
  size?: number;
  className?: string;
}

export const Krystal: React.FC<KrystalProps> = ({ size = 20, className }) => {
  return (
    <Image
      width={size}
      height={size}
      alt="Kyan Crystal"
      className={className}
      src="/images/common/kyan-crystal.png"
    />
  );
};
